import { registerComponent } from '@gig/magic-common';
import SetLimitsComponent from './set-limits.vue.js';

var SetLimits = registerComponent(SetLimitsComponent);

export { SetLimits };
